import { createFileRoute } from '@tanstack/react-router'

import { FEATURE_LEARNPATH_FILE_UPLOAD } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { LearnpathsAddElementsAssetDetails } from '@/learnpaths/components/LearnpathsAddElementsAssetDetails/LearnpathsAddElementsAssetDetails'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(file)/create/file/$elementId/$assetId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const hasLearnpathFileUploadFeature = useFeatures(
    FEATURE_LEARNPATH_FILE_UPLOAD,
  )

  if (!hasLearnpathFileUploadFeature) {
    return null
  }

  return (
    <LearnpathsAddElementsAssetDetails
      elementType="file"
      mode="create"
      {...params}
    />
  )
}
